module.exports = __webpack_public_path__ + "static/media/seguro.7a575cfd.png";